module.exports = __webpack_public_path__ + "img/arrow.87eb3de2.svg";